// extracted by mini-css-extract-plugin
module.exports = {"sendCodeSingleButton":"SendCodeSingleButton_sendCodeSingleButton__X8yHc","timeout":"SendCodeSingleButton_timeout___fBgH"};